import React from 'react';
import { BaseFormField } from './BaseFormField';

interface Option {
    value: string | number;
    label: string;
}

interface SelectInputProps {
    name: string;
    label: string;
    options: Option[];
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    onValueChange?: (value: string, values: any) => void;
}

export const SelectInput: React.FC<SelectInputProps> = ({
    name,
    label,
    options,
    placeholder = 'Please select...',
    required = false,
    disabled = false,
    onValueChange,
}) => (
    <div className="mb-4">
        <label className="fs-14 fw-400 mb-2">
            {label} {required && <span className="lt-text-error">*</span>}
        </label>
        <BaseFormField name={name}>
            {({ field, error, values, setFieldValue, setFieldTouched }) => (
                <>
                    <select
                        value={field.value || ''}
                        disabled={disabled}
                        onChange={(ev) => {
                            setFieldTouched(field.name);
                            setFieldValue(field.name, ev.target.value);
                            onValueChange?.(ev.target.value, { ...values, [field.name]: ev.target.value });
                        }}
                        className={`form-select ${error ? 'is-invalid' : ''}`}
                    >
                        <option value="">{placeholder}</option>
                        {options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {typeof error === 'string' && <small className="text-danger fs-12">{error}</small>}
                </>
            )}
        </BaseFormField>
    </div>
);
